import { createContext, useContext } from 'react';

const CartSettingsContext = createContext(null);
CartSettingsContext.displayName = 'CartSettings';
const useCartSettings = ()=>{
    const context = useContext(CartSettingsContext);
    if (context === null) {
        throw new Error('Missing CartSettings provider. You have to wrap the application with the CartSettingsProvider component from the @grandvisionhq/carts-v2 package.');
    }
    return context;
};

export { CartSettingsContext, useCartSettings };
//# sourceMappingURL=context.js.map
